import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { checkIfIsMulti } from "@utils/my-bets/helpers";

export default observer(function OfferTime(props: {
	offer: BetOffer;
	groupHasTitle: boolean;
}) {
	const myBetsStore = useContext(MyBetsStoreContext);

	const data = checkIfIsMulti(
		props.offer,
		myBetsStore,
		"bet__time--live",
		props.groupHasTitle
	);

	return <div className={"bet__time" + data.cssClass}>{data.time}</div>;
});
